import { List } from 'immutable';
import { useSelector } from 'react-redux';
import { selectCardsById } from './selectors';

/**
 * Cards the game refers to by id, like the Trainers attached to a Pokémon, as the catalog has them. What a card is
 * comes from the catalog only; the game says which cards. Ids the catalog doesn't have are left out.
 *
 * @param {List|undefined} cardIds
 * @returns {List<Map>}
 */
export default function useCards(cardIds) {
  const cardsById = useSelector(selectCardsById);

  return (cardIds || List()).map(id => cardsById.get(id)).filter(card => !!card);
}
